define('common/baseLayout',['require','app/app','glu/layout'],function(require) {
	'use strict';

	var App = require('app/app'),
		Layout = require('glu/layout');


	return Layout.extend({

		isViewOnly: function() {
			return App.user.isReadOnly();
		},

		isInternalUser: function() {
			return App.user.isInternalUser();
		}

	});
});

